var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "gantt-elastic__chart-dependency-lines-container",
      style: { ..._vm.root.style["chart-dependency-lines-container"] },
      attrs: { x: "0", y: "0", width: "100%", height: "100%" },
    },
    _vm._l(_vm.dependencyTasks, function (task) {
      return _c(
        "g",
        { key: task.id, attrs: { task: task } },
        _vm._l(task.dependencyLines, function (dependencyLine) {
          return _c("path", {
            key: dependencyLine.id,
            staticClass: "gantt-elastic__chart-dependency-lines-path",
            style: {
              ..._vm.root.style["chart-dependency-lines-path"],
              ...task.style["chart-dependency-lines-path"],
              ...task.style[
                "chart-dependency-lines-path-" + dependencyLine.task_id
              ],
            },
            attrs: { task: task, d: dependencyLine.points },
          })
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }